// USDT 合并展示，提交仍使用各网络对应的后台方式 ID。
export function withdrawalGroups(methods = []) {
  const groups = [];
  for (const method of methods) {
    if (method.currency === 'USDT') {
      if (!groups.some(item => item.id === 'USDT')) groups.push({ ...method, id: 'USDT', name: 'USDT' });
    } else groups.push(method);
  }
  return groups;
}

export function withdrawalNetworks(methods = []) {
  return methods.filter(method => method.currency === 'USDT').flatMap(method =>
    (method.networks || []).map(network => ({ key: String(method.id) + ':' + network, methodId: method.id, network }))
  );
}
